import React from "react"
import { connect } from "react-redux"
import Loader from "react-loader-spinner"
import { withRouter, Redirect } from "react-router-dom"

import axios from "axios"
import queryString from "query-string"
import ReactS3Uploader from "react-s3-uploader"
import * as utils from "../../Redux/Utils/actionUtils"
import VideoEditor from "../VideoEditor/VideoEditor"
import colors from "../../Constants/colors.js"
import VideoUploadProgress from "../VideoUploadProgress/VideoUploadProgress"
import VideoUploader from "../VideoUploader/VideoUploader"

export class VideoEditorContainer extends React.Component {
  constructor(props) {
    super(props)

    const { videoId } = queryString.parse(this.props.location.search)
    this.videoId = videoId

    this.thumbnailTimeStampPattern = new RegExp(
      /^(?:1[0-2]|0[0-9]):[0-5][0-9]:[0-5][0-9]$/
    )

    this.state = {
      hasError: false,
      initialized: false,
      categories: [],
      justUploaded: false,
      videoEdits: null,
      types: [],
      currentEvent: this.videoId ? "editing" : "selectingImage",
      uploadError: null,
      deleteVideoError: null
    }

    this.getSignedUrl = this.getSignedUrl.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.generateThumbnailFromTimestamp = this.generateThumbnailFromTimestamp.bind(
      this
    )
    this.onUploadStart = this.onUploadStart.bind(this)
    this.onError = this.onError.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.onUploadFinish = this.onUploadFinish.bind(this)
    this.publishVideo = this.publishVideo.bind(this)
    this.createVideo = this.createVideo.bind(this)
    this.setJustUploaded = this.setJustUploaded.bind(this)
    this.errorHandler = this.errorHandler.bind(this)
    this.updateVideoS3Values = this.updateVideoS3Values.bind(this)
    this.changeHandler = this.changeHandler.bind(this)
    this.deleteVideo = this.deleteVideo.bind(this)
    this.host = process.env.REACT_APP_API_URL
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true
    })
  }

  async generateThumbnailFromTimestamp(inputData) {
    if (
      this.state.videoEdits &&
      this.state.videoEdits[0].value &&
      this.thumbnailTimeStampPattern.test(this.state.videoEdits[0].value) &&
      !this.state.generatingThumbnail
    ) {
      this.setState({
        generatingThumbnail: true
      })

      const thumbnailRes = await axios.post(
        `${this.host}/generateVideoThumbnail`,
        {
          timestamp: this.state.videoEdits[0].value,
          url: this.state.video.s3_video_url
        },
        {
          headers: { Authorization: this.props.api.apiToken }
        }
      )

      if (!thumbnailRes.data) {
        this.setState({
          generatingThumbnail: false
        })

        return
      }

      const updatedVideoRes = await axios.put(
        `${this.host}/video`,
        {
          id: this.state.video.id,
          videoUpdates: {
            s3_thumbnail_url: thumbnailRes.data
          }
        },
        {
          headers: { Authorization: this.props.api.apiToken }
        }
      )

      this.setState({
        video: updatedVideoRes.data,
        generatingThumbnail: false
      })
    }
  }

  async updateVideoS3Values(videoUrl) {
    const thumbnailRes = await axios.post(
      `${this.host}/generateVideoThumbnail`,
      {
        url: videoUrl
      },
      {
        headers: { Authorization: this.props.api.apiToken }
      }
    )

    const updatedVideoRes = await axios.put(
      `${this.host}/video`,
      {
        id: this.videoId,
        videoUpdates: {
          s3_thumbnail_url: thumbnailRes.data,
          s3_video_url: videoUrl
        }
      },
      {
        headers: { Authorization: this.props.api.apiToken }
      }
    )

    // Normalize the updated video response to ensure type and category objects are preserved
    const updatedVideo = updatedVideoRes.data ? {
      ...updatedVideoRes.data,
      s3_thumbnail_url: updatedVideoRes.data.s3_thumbnail_url || updatedVideoRes.data.s3ThumbnailUrl,
      s3_video_url: updatedVideoRes.data.s3_video_url || updatedVideoRes.data.s3VideoUrl,
      type_id: updatedVideoRes.data.type_id || updatedVideoRes.data.typeId,
      category_id: updatedVideoRes.data.category_id || updatedVideoRes.data.categoryId,
      is_recommended: updatedVideoRes.data.is_recommended || updatedVideoRes.data.isRecommended,
      type: updatedVideoRes.data.type,
      category: updatedVideoRes.data.category
    } : null

    console.log('[VideoEditorContainer.updateVideoS3Values] Updated video:', {
      id: updatedVideo?.id,
      hasType: !!updatedVideo?.type,
      hasCategory: !!updatedVideo?.category,
      typeId: updatedVideo?.type?.id,
      categoryId: updatedVideo?.category?.id
    })

    this.setState({
      video: updatedVideo,
      currentEvent: "editing",
      justUploaded: true
    })
  }

  errorHandler() {
    this.setState({
      currentEvent: "error"
    })
  }

  async getSignedUrl(file, callback) {
    console.log('[VideoEditorContainer.getSignedUrl] Requesting signed URL:', {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size
    })
    
    try {
      const urlRes = await axios.post(
        `${this.host}/getSignedAWSUrl`,
        {
          fileName: file.name,
          fileType: file.type
        },
        {
          headers: {
            Authorization: this.props.api.apiToken
          }
        }
      )

      console.log('[VideoEditorContainer.getSignedUrl] Signed URL received:', {
        filename: urlRes.data.filename,
        publicUrl: urlRes.data.publicUrl,
        hasSignedUrl: !!urlRes.data.signedUrl
      })

      callback(urlRes.data)
    } catch (error) {
      console.error('[VideoEditorContainer.getSignedUrl] Error:', error)
      throw error
    }
  }

  onUploadFinish(fileData) {
    console.log('[VideoEditorContainer.onUploadFinish] Upload completed:', {
      fileData,
      publicUrl: fileData.publicUrl,
      hasVideoId: !!this.videoId,
      action: this.videoId ? 'updateVideoS3Values' : 'createVideo'
    })
    this.setState({
      currentEvent: "finalizing"
    })
    this.videoId
      ? this.updateVideoS3Values(fileData.publicUrl)
      : this.createVideo(fileData.publicUrl)
  }

  onProgress(percent) {
    this.setState({
      percentageComplete: percent
    })
  }

  onError(e) {
    console.log(e)
  }

  onUploadStart(file, next) {
    console.log('[VideoEditorContainer.onUploadStart] File selected:', {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
      isValidType: file.type === "video/mp4"
    })
    
    if (file.type === "video/mp4") {
      next(file)
      this.setState({
        currentEvent: "uploading"
      })
      console.log('[VideoEditorContainer.onUploadStart] Upload started')
    } else {
      console.error('[VideoEditorContainer.onUploadStart] Invalid file type:', file.type)
      this.setState({
        uploadError: "Video must be of type mp4. Please try again."
      })
    }
  }

  changeHandler(inputData) {
    this.setState({
      videoEdits: inputData
    })
  }

  async handleFileUpload(e) {
    e.preventDefault()
    const data = new FormData()
    data.append("video", e.target.files[0])
    data.append("name", "video")

    await axios.post(`${this.host}/uploadVideo`, data, {
      headers: {
        Authorization: this.props.api.apiToken,
        "Content-Type": "multipart/form-data"
      }
    })

    this.setState({
      uploadingFile: true
    })
  }

  async componentDidMount() {
    console.log("VideoEditorContainer.componentDidMount - fetching init data")
    const categories = await axios.get(`${this.host}/categories`, {
      headers: { Authorization: this.props.api.apiToken }
    })
    const types = await axios.get(`${this.host}/types`, {
      headers: { Authorization: this.props.api.apiToken }
    })

    // Maybe this gets called whenever there is an update to the button category
    // const buttonValuesRes = await axios.get(`${this.host}/buttonValues/`, {
    //   headers: { Authorization: this.props.api.apiToken },
    //   params: { partId: 3355 }
    // });

    // const tags = buttonValuesRes.data.map((button, i) => {
    //   return {
    //     name: button.name,
    //     button_value_id: button.pivot.button_value_id
    //   }
    // })

    const videoRes = this.videoId
      ? await axios.get(`${this.host}/video?videoId=${this.videoId}`, {
          headers: { Authorization: this.props.api.apiToken }
        })
      : null
    if (videoRes) {
      console.log('[VideoEditorContainer.componentDidMount] Raw video response:', {
        hasData: !!videoRes.data,
        isArray: Array.isArray(videoRes.data),
        dataLength: Array.isArray(videoRes.data) ? videoRes.data.length : 0,
        firstItem: videoRes.data && videoRes.data[0] ? {
          id: videoRes.data[0].id,
          title: videoRes.data[0].title,
          type_id: videoRes.data[0].type_id,
          category_id: videoRes.data[0].category_id,
          hasType: !!videoRes.data[0].type,
          hasCategory: !!videoRes.data[0].category,
          type: videoRes.data[0].type,
          category: videoRes.data[0].category
        } : null
      })
    }

    // Normalize video object to ensure snake_case fields for compatibility
    // IMPORTANT: Preserve type and category objects for dropdown selection
    let normalizedVideo = null
    if (videoRes && videoRes.data && videoRes.data[0]) {
      const rawVideo = videoRes.data[0]
      
      // Ensure type and category objects are preserved
      // If they exist, use them; otherwise create minimal objects from IDs
      let typeObj = rawVideo.type
      if (!typeObj && rawVideo.type_id) {
        // Find the type from the types list if available
        const typeFromList = types.data?.find(t => t.id === rawVideo.type_id)
        typeObj = typeFromList ? { id: typeFromList.id, name: typeFromList.name } : { id: rawVideo.type_id }
      }
      
      let categoryObj = rawVideo.category
      if (!categoryObj && rawVideo.category_id) {
        // Find the category from the categories list if available
        const categoryFromList = categories.data?.find(c => c.id === rawVideo.category_id)
        categoryObj = categoryFromList ? { id: categoryFromList.id, name: categoryFromList.name } : { id: rawVideo.category_id }
      }
      
      normalizedVideo = {
        ...rawVideo,
        s3_thumbnail_url: rawVideo.s3_thumbnail_url || rawVideo.s3ThumbnailUrl,
        s3_video_url: rawVideo.s3_video_url || rawVideo.s3VideoUrl,
        type_id: rawVideo.type_id || rawVideo.typeId,
        category_id: rawVideo.category_id || rawVideo.categoryId,
        is_recommended: rawVideo.is_recommended || rawVideo.isRecommended,
        // Preserve type and category objects for dropdown selection
        type: typeObj,
        category: categoryObj
      }
      
      console.log('[VideoEditorContainer.componentDidMount] Normalized video:', {
        id: normalizedVideo.id,
        title: normalizedVideo.title,
        type_id: normalizedVideo.type_id,
        category_id: normalizedVideo.category_id,
        hasType: !!normalizedVideo.type,
        hasCategory: !!normalizedVideo.category,
        typeId: normalizedVideo.type?.id,
        typeName: normalizedVideo.type?.name,
        categoryId: normalizedVideo.category?.id,
        categoryName: normalizedVideo.category?.name,
        typesAvailable: types.data?.length || 0,
        categoriesAvailable: categories.data?.length || 0
      })
    }

    this.setState({
      initialized: true,
      categories: categories.data,
      types: types.data,
      video: normalizedVideo
      // tags: tags
    })
  }

  async publishVideo(inputData, videoId) {
    try {
      console.log('[VideoEditorContainer.publishVideo] Publishing video:', {
        videoId,
        inputDataCount: inputData.length
      })
      
      const processedInputs = inputData.map((input) => {
        if (input.inputType === "select") {
          return input.value
            ? {
                ...input,
                value: input.options.find(
                  (option) => option.value === input.value
                ).id
              }
            : input
        }
        return input
      })

      const videoUpdates = utils.processInputData(processedInputs).video
      console.log('[VideoEditorContainer.publishVideo] Video updates:', {
        videoUpdates,
        hasType: !!videoUpdates.type,
        hasCategory: !!videoUpdates.category,
        typeId: videoUpdates.type,
        categoryId: videoUpdates.category
      })

      const updateRes = await axios.put(
        `${this.host}/video`,
        {
          id: videoId,
          videoUpdates: videoUpdates
        },
        {
          headers: { Authorization: this.props.api.apiToken }
        }
      )

      console.log('[VideoEditorContainer.publishVideo] Update response:', {
        hasData: !!updateRes.data,
        responseData: updateRes.data,
        hasType: !!updateRes.data?.type,
        hasCategory: !!updateRes.data?.category,
        typeId: updateRes.data?.type?.id,
        categoryId: updateRes.data?.category?.id
      })

      // Update local state with the updated video data (including type and category)
      if (updateRes.data) {
        const updatedVideo = {
          ...updateRes.data,
          s3_thumbnail_url: updateRes.data.s3_thumbnail_url || updateRes.data.s3ThumbnailUrl,
          s3_video_url: updateRes.data.s3_video_url || updateRes.data.s3VideoUrl,
          type_id: updateRes.data.type_id || updateRes.data.typeId,
          category_id: updateRes.data.category_id || updateRes.data.categoryId,
          is_recommended: updateRes.data.is_recommended || updateRes.data.isRecommended,
          type: updateRes.data.type,
          category: updateRes.data.category
        }
        
        this.setState({
          video: updatedVideo
        })
        
        console.log('[VideoEditorContainer.publishVideo] Updated local state with video:', {
          id: updatedVideo.id,
          hasType: !!updatedVideo.type,
          hasCategory: !!updatedVideo.category
        })
      }

      this.props.history.push("/digitalLibrary")
    } catch (error) {
      console.error('[VideoEditorContainer.publishVideo] Error publishing video:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status
      })
      throw error
    }
  }

  setJustUploaded() {
    this.setState({
      justUploaded: true
    })
  }

  async createVideo(url) {
    try {
      console.log("VideoEditorContainer.createVideo - starting", { url })
      const res = await axios.post(
        `${this.host}/video`,
        {
          publicVideoUrl: url
        },
        {
          headers: { Authorization: this.props.api.apiToken }
        }
      )

      const body = res && res.data
      console.log("VideoEditorContainer.createVideo - raw response", { body })
      let createdVideo = null

      if (Array.isArray(body)) {
        createdVideo = body[0]
      } else if (body && Array.isArray(body.data)) {
        createdVideo = body.data[0]
      } else if (body && Array.isArray(body.rows)) {
        // Adonis Lucid Collection shape
        createdVideo = body.rows[0]
      } else if (body && body.id) {
        createdVideo = body
      }

      if (!createdVideo || !createdVideo.id) {
        console.error("VideoEditorContainer.createVideo - missing created id", {
          body,
          createdVideo
        })
        this.setState({
          uploadError: "Video creation failed. Please try again.",
          currentEvent: "error"
        })
        return
      }

      // Normalize the video object to ensure snake_case fields for compatibility
      const normalizedVideo = {
        ...createdVideo,
        s3_thumbnail_url: createdVideo.s3_thumbnail_url || createdVideo.s3ThumbnailUrl,
        s3_video_url: createdVideo.s3_video_url || createdVideo.s3VideoUrl,
        type_id: createdVideo.type_id || createdVideo.typeId,
        category_id: createdVideo.category_id || createdVideo.categoryId,
        is_recommended: createdVideo.is_recommended || createdVideo.isRecommended
      }

      console.log("VideoEditorContainer.createVideo - success", {
        createdVideo: normalizedVideo
      })
      this.setState({
        video: normalizedVideo,
        justUploaded: true,
        currentEvent: "editing"
      })
      this.props.history.push(`/digitalLibraryAdmin?videoId=${normalizedVideo.id}`)
    } catch (e) {
      console.error("VideoEditorContainer.createVideo - error", e)
      this.setState({
        uploadError: "Video creation failed. Please try again.",
        currentEvent: "error"
      })
    }
  }

  async deleteVideo() {
    try {
      await axios.delete(`${this.host}/video`, {
        data: {
          videoId: this.state.video.id
        },
        headers: { Authorization: this.props.api.apiToken }
      })

      this.setState({ deleteVideoError: null })
      this.props.history.push("/digitalLibrary")
    } catch (error) {
      this.setState({
        deleteVideoError: "An error has ocurred. Please try again."
      })
    }
  }

  getVideoComponent() {
    switch (this.state.currentEvent) {
      case "uploading":
        return (
          <VideoUploadProgress
            percentageComplete={this.state.percentageComplete}
          />
        )
      case "editing":
        return (
          <VideoEditor
            changeHandler={this.changeHandler}
            deleteVideo={this.deleteVideo}
            publishVideo={this.publishVideo}
            video={this.state.video}
            generatingThumbnail={this.state.generatingThumbnail}
            types={this.state.types}
            justUploaded={this.state.justUploaded}
            generateThumbnailFromTimestamp={this.generateThumbnailFromTimestamp}
            categories={this.state.categories}
            tagCategories={["Values, Industries"]}
            deleteVideoError={this.state.deleteVideoError}
          />
        )
      // tags={this.state.tags}
      case "finalizing":
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Loader
              type="Oval"
              color={colors.midnight}
              height="100"
              width="100"
            />
            <h1 style={{ marginTop: "20px" }}> Finalizing Upload... </h1>
          </div>
        )
      case "selectingImage":
        return (
          <VideoUploader
            uploadError={this.state.uploadError}
            startUpload={this.startUpload}
            createVideo={this.createVideo}
          />
        )
      case "error":
        console.error("VideoEditorContainer.render - error state", {
          uploadError: this.state.uploadError,
          currentEvent: this.state.currentEvent,
          video: this.state.video,
          videoId: this.videoId
        })
        return (
          <h1
            style={{
              display: "flex",
              width: "100%",
              height: "100vh",
              color: colors.fadedRed,
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px"
            }}
          >
            {" "}
            Oops! We had trouble with the upload. Please refresh the page and
            try again.
          </h1>
        )
      default:
        console.error("VideoEditorContainer.render - unexpected state", {
          currentEvent: this.state.currentEvent,
          initialized: this.state.initialized,
          video: this.state.video
        })
        return (
          <h1
            style={{
              display: "flex",
              width: "100%",
              height: "100vh",
              color: colors.fadedRed,
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px"
            }}
          >
            {" "}
            Oops! We had trouble with the upload. Please refresh the page and
            try again.
          </h1>
        )
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        <ReactS3Uploader
          style={{
            opacity: 0,
            height: "0px"
          }}
          s3path="/videos/"
          id="file-upload"
          onFinish={this.onUploadFinish}
          preprocess={this.onUploadStart}
          getSignedUrl={this.getSignedUrl}
          contentDisposition="auto"
          uploadRequestHeaders={{}}
          onProgress={this.onProgress}
          onError={this.errorHandler}
          autoUpload
        />

        {this.state.hasError ? (
          <Redirect to="/error" />
        ) : this.state.initialized ? (
          this.getVideoComponent(this.getSignedUrl)
        ) : (
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Loader
              type="Oval"
              color={colors.midnight}
              height="100"
              width="100"
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    api: state.api
  }
}

export default withRouter(connect(mapStateToProps)(VideoEditorContainer))
